// Real testimonials from Ready Set Code (HiSawyer)
export const testimonials = [
  {
    id: 1,
    name: "Rebecca N.",
    location: "Homestead Elementary",
    rating: 5,
    quote: "Learning how to build amazing things",
    program: "Build and Code Your Own Smart Recycling Can",
    date: "Nov 2025"
  },
  {
    id: 2,
    name: "Kaushik V.",
    location: "Ready Set Code at Downtown Aurora",
    rating: 5,
    quote: "Very engaged instructors",
    program: "FIRST Lego League Challenge",
    date: "Nov 2025"
  },
  {
    id: 3,
    name: "Calvin T.",
    location: "Homestead Elementary",
    rating: 5,
    quote: "It was super fun",
    program: "Build and Code Your Own Moon Lamp",
    date: "Oct 2025"
  },
  {
    id: 4,
    name: "Katherine H.",
    location: "Homestead Elementary",
    rating: 5,
    quote: "Learning how to change colors",
    program: "Build and Code Your Own Moon Lamp",
    date: "Oct 2025"
  },
  {
    id: 5,
    name: "Davide P.",
    location: "Bednarcik Jr High",
    rating: 5,
    quote: "What we made was fun",
    program: "Build and Code Your Own Robotic Car",
    date: "Aug 2025"
  },
  {
    id: 6,
    name: "Sarah M.",
    location: "Scullen Middle School",
    rating: 5,
    quote: "My son learned robotics and Python in one week. He can't wait for summer camp!",
    program: "Summer STEM Camp",
    date: "Jun 2025"
  },
  {
    id: 7,
    name: "Jennifer L.",
    location: "Bednarcik JHS",
    rating: 5,
    quote: "Best summer camp investment we've made. Real STEM skills, not just arts & crafts.",
    program: "STEM Week",
    date: "Jul 2025"
  },
  {
    id: 8,
    name: "Mike T.",
    location: "Waubonsie Valley HS",
    rating: 5,
    quote: "The instructors were patient and knowledgeable. My son wants to come back next year!",
    program: "Robotics Camp",
    date: "Aug 2025"
  }
];

export const overallRating = {
  score: 4.9,
  count: 97,
  source: "HiSawyer Reviews"
};
